// --------------------------------------------------------------------------
// Google tag manager code for the registration form
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

/* global dataLayer */

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function init() {

        /**
         * Google tag manager submission function
         */
        function pushSubmissionGaDataLayer() {
            var previousDonate = 'No';
            if (context.find('[data-binding="previous-donate"]').is(':checked')) {
                previousDonate = 'Yes';
            }
            var contactPreferences = '';
            context.find('[data-binding="contact-preference"]:checked').each(function () {
                contactPreferences += $(this).siblings('label').find('span').text() + ', ';
            });

            contactPreferences = contactPreferences.substring(0, contactPreferences.length - 2);

            dataLayer.push({ 'category': 'registrationComplete', 'previousDonate': previousDonate, 'contactPreferences': contactPreferences });
        }

        /**
         * Google tag manager abadonement function
         */
        function pushAbandonmentGaDataLayer() {

            var formFields = context.find('[data-val-required]'),
                completedFields = '';
            //Loop through form and create array of completed fields
            $.each(formFields, function (index, formField) {
                if ($(formField).is('input[type=text]') || $(formField).is('input[type=password]') || $(formField).is('select')) {
                    if ($(formField).val() !== '' && formField.id !== 'Address_Country') {
                        completedFields += $(formField).parent().find('label').text() + ', ';
                    }
                }
            });

            completedFields = completedFields.substring(0, completedFields.length - 2);

            if (completedFields.length !== 0) {
                //Push the data to google tag manager
                dataLayer.push({ 'event': 'registrationAbandonement', 'completedFormFields': completedFields });
            }
        }

        context.on('click', '[data-binding="registration-submit"]', function () {
            pushSubmissionGaDataLayer();
        });

        // Form abandonment
        window.onbeforeunload = function () {
            pushAbandonmentGaDataLayer();
        };
        context.find('form').on('submit', function () {
            window.onbeforeunload = null;

            var isValid = context.find('form').valid();
            if (isValid) {
                var $registerBtn = $(this).find('[data-binding="registration-submit"]');
                var $tempRegisterBtn = $registerBtn.clone();
                $tempRegisterBtn.removeAttr('id name data-binding').prop('disabled', true);
                $registerBtn.hide().after($tempRegisterBtn);
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/register-form-tracking.js
// module id = 208
// module chunks = 0